// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"cdfbcc3c448eb675","8194":"89a8ef34507ef6c9"}[chunkId] + ".css";
};